import { Navigate, createBrowserRouter } from "react-router-dom";
import Page404 from "containers/Page404/Page404";
import CheckOutPage from "containers/CheckOutPage/CheckOutPage";
import PayPage from "containers/PayPage/PayPage";
import AccountBilling from "containers/AccountPage/AccountBilling";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import PageSubcription from "containers/PageSubcription/PageSubcription";
import { PageEmailConfirmation } from "containers/PageEmailConfirmation/EmailConfirmation";
import ListingStayDetailPage from "containers/ListingDetailPage/listing-stay-detail/ListingStayDetailPage";
import PageForgotPassword from "containers/PageForgotPassword";
import { PageResetPassword } from "containers/PageForgotPassword/PageResetPassword";
import { BookingDone } from "containers/BookingDone/BookingDone";
import PageHome from "containers/PageHome/PageHome";
import { PageEditEmailConfirmation } from "containers/PageEmailConfirmation/EditEmailConfirmation";
import { UpdatePaymentDataTemplate } from "containers/UpdatePaymentData/template";

export const MyRoutes = createBrowserRouter(
  [
    {
      path: "/",
      element: <PageLogin />,
    },
    {
      path: "/login",
      element: <Navigate to="/" />,
    },
    {
      path: "/signup",
      element: <PageSignUp />,
    },
    {
      path: "/forgot-password",
      element: <PageForgotPassword />,
    },
    {
      path: "/form-forgot-password",
      element: <PageResetPassword />,
    },
    {
      path: "/home",
      element: <PageHome />,
    },
    {
      path: "/hotel/:destination_id/:hotel_id",
      element: <ListingStayDetailPage />,
    },
    {
      path: "/booking-done/:id",
      element: <BookingDone />,
    },
    {
      path: "/booking",
      element: <Navigate to="/account-billing#reservations" />,
    },
    {
      path: "/plans",
      element: <PageSubcription />,
    },
    {
      path: "/checkout",
      element: <CheckOutPage />,
    },
    {
      path: "/pay-done",
      element: <PayPage />,
    },
    {
      path: "/account-billing",
      element: <AccountBilling />,
    },
    {
      path: "/account/update-payment",
      element: <UpdatePaymentDataTemplate />,
    },
    {
      path: "/confirm",
      element: <PageEmailConfirmation />,
    },
    {
      path: "/confirm-email",
      element: <PageEditEmailConfirmation />
    },
    {
      path: "*",
      element: <Page404 />,
    },
  ],
  {
    basename: process.env.PUBLIC_URL,
  }
);
